import { nextTick } from 'vue';
import { createI18n } from 'vue-i18n';

import de from './de.json'
import fr from './fr.json'
import en from './en.json'

let i18n;

export const SUPPORT_LOCALES = ['de', 'fr', 'en'];

export function setI18nLanguage(locale) {
  switch (locale) { // Workaround due to import problems in loadLocaleMessages
    case "en":
      i18n.global.setLocaleMessage(locale, en);
      break;

    case "fr":
      i18n.global.setLocaleMessage(locale, fr);
      break;

    default:
      i18n.global.setLocaleMessage(locale, de);
      break;
  }


  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }

  document.querySelector('html').setAttribute('lang', locale);
  ('dm-ae-lang', locale);
}

export async function loadLocaleMessages(locale) {
  const messages = await import(/* @vite-ignore */ `./${locale}.json`);
  i18n.global.setLocaleMessage(locale, messages);
  return nextTick();
}

export default function setupI18n() {
  if (!i18n) {
    let locale = localStorage.getItem('dm-ae-lang') || 'en';

    i18n = createI18n({
      globalInjection: true,
      legacy: false,
      locale: locale,
      fallbackLocale: 'en'
    });

    setI18nLanguage(locale);
  }
  return i18n;
}
